import EventTimeline from './EventTimeline'

export default EventTimeline
